import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-arrow-down",
  "use": "icon-arrow-down-usage",
  "viewBox": "0 0 7 4",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 7 4\" id=\"icon-arrow-down\"><path d=\"M.446.015c-.355 0-.582.474-.31.747L3.194 3.82a.421.421 0 0 0 .612 0L6.865.762c.265-.266.058-.747-.306-.747H.446z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol